module.exports = __webpack_public_path__ + "img/con_5.8579923f.svg";